// Dependencies
import { baanRueJaiClient } from "../../../../dependencies"

// LINE Notify Use Cases
export const useCases = baanRueJaiClient.admin.lineNotify


// WEBPACK FOOTER //
// ./src/features/managements/modules/line-notify/LineNotifyService.js